import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

/**
 * Tooltips component
 */
export default class Tooltips extends withBreakpointObserver(Base) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Tooltips',
    refs: ['slider', 'prev', 'next', 'pagination', 'dots[]'],
  };

  /**
   *
   */
  mounted() {
    this.currentDot = this.$refs.dots[0];

    this.slider = new Swiper(this.$refs.slider, {
      modules: [Navigation, Pagination],
      slidesPerView: 'auto',
      // Sans ça toutes les légendes prennent la hauteur de la plus longue :
      // les plus courtes laissent un vide sous elles, très visible en mobile
      // où la fiche technique suit immédiatement.
      autoHeight: true,
      navigation: {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev,
      },
      pagination: {
        el: this.$refs.pagination,
        type: 'fraction',
      },
      on: {
        slideChange: (slider) => {
          this.switchDots(slider.activeIndex);
        },
      },
    });
  }

  /**
   * Click on Dots
   * @param {object} props Props
   * @param {object} props.index current index
   * @returns {void}
   */
  onDotsClick({ index }) {
    this.slider.slideTo(index);
    this.switchDots(index);
  }

  /**
   * Switch Dots
   * @param {number} index dots state
   */
  switchDots(index) {
    this.currentDot.parentNode.classList.remove('active');
    this.currentDot = this.$refs.dots[index];
    this.currentDot.parentNode.classList.add('active');
  }
}
